import { connect } from "react-redux";
import injectIntl from "../../../../../common/helpers/injectIntl";
import { setPlanMeta } from "../../../../store/plan/actions";
import { post } from "../../../../actions/general";

import Pitch from "./Pitch";
import { IStateTree } from "../../../../store/interfaces";
import { IUser } from "../../../../store/user/models";

const mapStateToProps = ({ user }: IStateTree) => ({ user: user as IUser });

export default connect(mapStateToProps, { post, setPlanMeta })(injectIntl(Pitch));
